import { useQuery } from '@tanstack/react-query';
import { awaitJSON, LinearLambdaFetch } from '@src/utils/fetch-utils';
import { LinearCpmRow } from './linear-cpms-constants';
import { sortLinearCpmRows } from './linear-cpms-utils';

export const useLinearCpms = (demos: string[]): ReturnType<typeof useQuery<LinearCpmRow[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['linearCpms', [...demos].sort()],
    // With no demos selected, the lambda's `where demo in (${demosStr})` becomes `in ()` --
    // invalid SQL, a guaranteed 500. Skip the request entirely rather than let the user hit
    // an error from an empty dropdown.
    enabled: demos.length > 0,
    queryFn: async (): Promise<LinearCpmRow[]> => {
      const rows = await awaitJSON<LinearCpmRow[]>(
        await LinearLambdaFetch('/cpms', { method: 'POST', body: { demos } })
      );
      return sortLinearCpmRows(rows);
    }
  });
